module.exports = __webpack_public_path__ + "media/sub7-4-3.f9b20669.mp4";